import React, { useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../Context/LanguageContext';
import AOS from 'aos';
import 'aos/dist/aos.css';


function ServiceIcon({ text, icon, link, subtitle ,description}) {
  const { texts } = useContext(LanguageContext);
  const [finalTitle, setFinalTitle] = useState(text); 

  useEffect(()=>{
   if(text=='Nma Clothes Company Brand'){
     setFinalTitle(texts.brand_nma_clothes_company);
   }else if(text=='GARO COMPANY'){
     setFinalTitle(texts.brand_garo_company);
   }
  }, [text, texts])


  return (
    <div className='group h-full'>
      <div className='bg-white rounded-2xl sm:rounded-3xl shadow-medium hover:shadow-large transition-all duration-300 transform hover:-translate-y-2 p-4 sm:p-6 md:p-8 lg:p-10 h-full flex flex-col items-center text-center border border-neutral-100'>
        {/* Icon Container */}
        <div className='relative mb-4 sm:mb-6 md:mb-8'>
          <div className='absolute inset-0 bg-gradient-to-br from-primary-100 to-primary-200 rounded-xl sm:rounded-2xl transform rotate-6 group-hover:rotate-12 transition-transform duration-300'></div>
          <div className='relative bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 md:p-6 shadow-soft'>
            <img 
              className='w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain group-hover:scale-110 transition-transform duration-300'
              src={icon} 
              alt="brand icon" 
            />
          </div>
        </div>

        {/* Content */}
        <div className='flex-1 flex flex-col justify-between items-center'>
          <h3 className='text-neutral-900 text-lg sm:text-xl md:text-2xl font-bold mb-4 sm:mb-6 leading-tight'>
            {finalTitle}
          </h3>
          
          <a 
            href={link} 
            target="_blank" 
            rel="noopener noreferrer"
            className='group/link inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary-400 to-primary-500 hover:from-primary-500 hover:to-primary-600 text-white font-semibold px-4 sm:px-6 py-2 sm:py-3 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-lg w-full sm:w-auto min-w-[160px] sm:min-w-[200px] md:w-64'
          >
            <span>{texts.button_visit_us}</span>
            <svg 
              className="w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-300" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-4 right-4 w-3 h-3 bg-primary-300 rounded-full opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>
        <div className="absolute bottom-6 left-4 w-2 h-2 bg-primary-400 rounded-full opacity-30 group-hover:opacity-60 transition-opacity duration-300"></div>
      </div>
    </div>
  );
}

export default ServiceIcon;
